import React from "react";

const ButtonNotificationMenu = (props) => {
  const { onClick, label, isDisabled } = props;
  return (
    <button
      onClick={onClick}
      disabled={isDisabled}
      className="notification-print-button"
    >
      {label}
    </button>
  );
};

export default ButtonNotificationMenu;
